/*
  Free-shipping Jelly Mask add-on: the cart switch.

  Markup and eligibility live in snippets/free-ship-upsell.liquid, rendered
  inside .cart--shipping, which the theme re-renders after every cart change.
  So this file only changes the cart, through the theme's own Cart class, and
  the fresh server HTML brings back the switch in its new state. Loaded from
  layout/theme.liquid because scripts inside swapped cart HTML never run.
*/
(function () {
  if (window.__spwFreeShipUpsellBound) return;
  window.__spwFreeShipUpsellBound = true;

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function cartClass() {
    return (window.customElements && customElements.get('cart-element')) || null;
  }

  function route(name, fallback) {
    var routes = window.Shopify && window.Shopify.routes;
    return ((routes && routes[name]) || fallback) + '.js';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' ' + res.status);
      return res.json();
    });
  }

  function reload() {
    window.location.reload();
  }

  function addSachet(root, Cart) {
    var body = {
      items: [{
        id: Number(root.dataset.variantId),
        quantity: 1,
        properties: { _upsell: root.dataset.tag }
      }]
    };

    if (Cart && typeof Cart.addItems === 'function') {
      body.sections = Cart.sections.join(',');
      return Cart.addItems({ method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) });
    }
    return post(route('cart_add', '/cart/add'), body).then(reload);
  }

  function removeSachet(root, Cart) {
    var body = { id: root.dataset.lineKey, quantity: 0 };

    if (!(Cart && typeof Cart.updateAllHtml === 'function')) {
      return post(route('cart_change', '/cart/change'), body).then(reload);
    }
    body.sections = Cart.sections;
    return post(route('cart_change', '/cart/change'), body).then(function (data) {
      Cart.fillBasket(data.items);
      Cart.updateTotals(data.item_count);
      Cart.updateAllHtml(data.sections);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-spw-fsu-toggle]');
    if (!button) return;
    var root = button.closest('[data-spw-fsu]');
    if (!root) return;

    event.preventDefault();
    if (root.hasAttribute('data-busy')) return;

    var turningOn = button.getAttribute('aria-checked') !== 'true';
    if (!turningOn && !root.dataset.lineKey) return;

    var view = root.dataset.view;
    var hadFocus = document.activeElement === button;
    var errorEl = root.querySelector('[data-spw-fsu-error]');
    var Cart = cartClass();

    root.setAttribute('data-busy', '');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-checked', turningOn ? 'true' : 'false');
    if (errorEl) errorEl.hidden = true;

    var request = turningOn ? addSachet(root, Cart) : removeSachet(root, Cart);

    request.then(function () {
      // The theme swaps .cart--shipping synchronously. If this switch is still
      // attached, the re-render did not happen and the page is out of date.
      if (document.contains(root)) {
        reload();
        return;
      }
      if (hadFocus) {
        var next = document.querySelector('[data-spw-fsu][data-view="' + view + '"] [data-spw-fsu-toggle]');
        if (next) next.focus({ preventScroll: true });
      }
    }).catch(function (err) {
      console.warn('[free-ship-upsell]', err);
      if (!document.contains(root)) return;
      root.removeAttribute('data-busy');
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-checked', turningOn ? 'false' : 'true');
      if (errorEl) errorEl.hidden = false;
    });
  });
})();
